import {useEffect} from 'react';
import {useQuery} from '@apollo/client';
import {
    GET_ACCOUNT_BIND_DSP,
    GetAccountBindDspResponse,
} from '../graphql/queries/getAccountBindDsp';
import useDspWarehouseStore from '../store/dspWarehouseStore';

/**
 * 保证 dspWarehouseStore 的 dspId / warehouses 已就绪。
 *
 * 背景：dspId / warehouses 此前只由 DspHomePage 在进入首页时回填 store，且 store 无持久化。
 * 用户刷新 / URL 直达客诉列表页或历史页时，未经过首页，store 仍为初始 null，
 * 导致依赖 dspId 的查询被 skip（红点与列表数据均不加载）。
 *
 * 本 hook 在需要 dspId 的页面调用：拉取 getAccountBindDsp（无入参、纯 token，Apollo 缓存复用），
 * 返回后将当前账号的 dsp.id / warehouses 回填 store。始终按 token 取，无跨账号残留问题。
 */
const useEnsureDspContext = (): void => {
    const setWarehouses = useDspWarehouseStore((state) => state.setWarehouses);
    const setDspId = useDspWarehouseStore((state) => state.setDspId);

    const {data} = useQuery<GetAccountBindDspResponse>(GET_ACCOUNT_BIND_DSP);

    useEffect(() => {
        if (data?.dsp?.warehouses) {
            setWarehouses(data.dsp.warehouses);
        }
        if (data?.dsp?.id != null) {
            setDspId(Number(data.dsp.id));
        }
    }, [data?.dsp?.warehouses, data?.dsp?.id, setWarehouses, setDspId]);
};

export default useEnsureDspContext;
